import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonials-heading" className="border-b border-navy-700 bg-navy" data-id="element-205" data-mp="3kr5uq9dydbmc">
      <div className="mx-auto max-w-page px-4 py-12 sm:px-5 lg:py-20" data-id="element-206" data-mp="3fxun461bgqtd">
        <h2 id="testimonials-heading" className="font-display text-[10px] font-bold uppercase tracking-[0.22em] text-steel sm:text-xs sm:tracking-[0.26em]" data-id="element-207" data-mp="3azjefymrcmcq">
          From teachers already running the system
        </h2>

        <div className="mt-8 grid gap-10 sm:mt-10 lg:grid-cols-2 lg:gap-16" data-id="element-208" data-mp="3228xpxr6850f">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col" data-id="element-209" data-mp="2s28ba2y098s0">
              <QuoteIcon className="h-6 w-6 text-gold" aria-hidden="true" strokeWidth={2.5} data-id="element-210" data-mp="v9g9pm6l60om" />
              <blockquote className="mt-5 font-display text-lg font-medium leading-relaxed text-white sm:text-xl" data-id="element-211" data-mp="qac3n4eykj2i">
                {testimonial.quote}
              </blockquote>
              <figcaption className="mt-auto flex flex-wrap items-center gap-3 pt-7" data-id="element-212" data-mp="h4n6gjawodem">
                <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-213" data-mp="m6m7hmj6ay8e">
                  {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-214" data-mp="7a4ukqvc5bjq" />)}
                </div>
                <span className="text-xs uppercase tracking-[0.12em] text-mist" data-id="element-215" data-mp="14vsiendq6ljn">
                  {testimonial.name} · {testimonial.role} · {testimonial.city}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}